






































import { Component, Prop, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { LoginController } from "@proxy/LoginController";
import * as ApplicationStore from "@src/store/applicationStore";

@Component
export default class Login extends Vue {
    @Prop() isOfba: boolean;
    @Prop() reportId?: number;
    @Prop() returnUrl?: string;

    private loginController: LoginController = new LoginController();

    constructor() {
        super();
    }

    mounted() {
        ApplicationStore.updateIsOfba(this.$store, this.isOfba);
    }

    private validateClass(name): any {
        return {
            "is-danger": this.$validator.errors.has(name)
        };
    }

    private loginValidate(submitEvent) {
        this.$validator.validateAll().then((isValid) => {
            if (isValid) {
                submitEvent.target.submit();
            }
        });
    }

    private getLoginLink(): string {
        return this.loginController.loginLink();
    }
}
